import { z } from "zod";
/** Contrato compartilhado web + API (FASE-05-T11). */
export const createEmployeeNoteSchema = z.object({
    text: z
        .string({ required_error: "Texto obrigatório" })
        .trim()
        .min(1, "Texto obrigatório")
        .max(500, "Máximo de 500 caracteres"),
});
//# sourceMappingURL=create-employee-note.js.map